import { Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { MatTable, MatTableDataSource } from '@angular/material/table';

@Component({
	selector: 'app-bag-payment-term-list-table-summary',
	templateUrl: './bag-payment-term-list-table-summary.component.html',
	styleUrls: ['./bag-payment-term-list-table-summary.component.scss'],
})
export class BagPaymentTermListTableSummaryComponent implements OnChanges {
	@ViewChild('dataTable') table: MatTable<any>;
	@Input() data;
	@Input() tableColumns = [];
	matData = new MatTableDataSource<any>();
	protected tableKeys: string[];
	constructor() {}

	ngOnChanges(): void {
		if (!this.data) {
			return;
		}
		this.loadData();
	}

	protected loadData(): void {
		this.matData.data = this.data;
		this.convertData(this.matData.data);
	}

	protected convertData(data) {
		this.tableKeys = this.tableColumns.map((col) => col.id);
		this.matData.data = data;
	}
}
